import React, { useState, useEffect } from "react";
import { Box, LinearProgress } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useLoading } from "../contexts/LoadingContext";

const TopProgressBar = () => {
  const [routeLoading, setRouteLoading] = useState(false);
  const [routeProgress, setRouteProgress] = useState(0);
  const location = useLocation();
  const { loading: contextLoading, progress: contextProgress } = useLoading();

  // 监听路由变化，显示路由切换进度条
  useEffect(() => {
    setRouteLoading(true);
    setRouteProgress(0);
    
    // 更快速的页面加载进度
    const timer1 = setTimeout(() => setRouteProgress(30), 50);
    const timer2 = setTimeout(() => setRouteProgress(70), 150);
    const timer3 = setTimeout(() => setRouteProgress(100), 300);
    const timer4 = setTimeout(() => {
      setRouteLoading(false);
      setRouteProgress(0);
    }, 400);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      clearTimeout(timer4);
    };
  }, [location.pathname]);

  // 确定当前显示的加载状态
  const isLoading = contextLoading || routeLoading;
  const currentProgress = contextLoading ? contextProgress : routeProgress;

  if (!isLoading) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 2000,
        height: 2,
      }}
    >
      <LinearProgress
        variant={currentProgress === 0 ? "indeterminate" : "determinate"}
        value={currentProgress}
        sx={{
          height: 2,
          backgroundColor: "transparent",
          "& .MuiLinearProgress-bar": {
            backgroundColor: "#4285f4",
            transition: "transform 0.2s cubic-bezier(0.4, 0.0, 0.2, 1)",
          },
          "& .MuiLinearProgress-bar1Indeterminate": {
            background: "linear-gradient(90deg, transparent, #4285f4, transparent)",
            animation: "googleIndeterminate1 2s cubic-bezier(0.23, 1, 0.32, 1) infinite",
          },
          "& .MuiLinearProgress-bar2Indeterminate": {
            background: "linear-gradient(90deg, transparent, #4285f4, transparent)",
            animation: "googleIndeterminate2 2s cubic-bezier(0.23, 1, 0.32, 1) 0.75s infinite",
          },
          "@keyframes googleIndeterminate1": {
            "0%": {
              left: "-35%",
              right: "100%",
            },
            "60%": {
              left: "100%",
              right: "-90%",
            },
            "100%": {
              left: "100%",
              right: "-90%",
            },
          },
          "@keyframes googleIndeterminate2": {
            "0%": {
              left: "-200%",
              right: "100%",
            },
            "60%": {
              left: "107%",
              right: "-8%",
            },
            "100%": {
              left: "107%",
              right: "-8%",
            },
          },
        }}
      />
    </Box>
  );
};

export default TopProgressBar;